export default "__VITE_ASSET__CPrQG6uG__"